import * as styles from '@core/components/ImageViewer/ImageViewer.css';
import { Spinner } from '@soteria/design-system-ve';

/**
 * Loading state component
 */
export function ImageLoading() {
  return (
    <div className={styles.loadingContainer}>
      <Spinner aria-label="Loading image" size="large" />
    </div>
  );
}
